<template>
  <div>If you see this page please notify developers and send sequence of clicks that yielded this page</div>
</template>

<script>
import VueRouter from 'vue-router'

export default {
  name: 'Redirector',
  props: {
    destination: {
      type: String,
      default: 'Dashboard'
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // A navigation the router declines - e.g. requiresAuth sending a signed-out user to login - is not an error anyone
    // can act on; left uncaught it surfaced as an unhandled rejection. Anything else still throws.
    redirect: function () {
      return this.$router.replace({name: this.destination}).catch((failure) => {
        if (!VueRouter.isNavigationFailure(failure)) throw failure
      })
    }
  },
  // Not returned: Vue 2.7 would catch a returned promise and only console.error it, hiding a real failure (e.g. a route
  // chunk that fails to load after a deploy) from Sentry, which reports unhandled rejections.
  mounted: function () {
    this.redirect()
  }
}

</script>
